export const challengeMixin = {
  methods: {
    challengeType(challenge) {
      if (challenge.isPreventative) {
        return "Preventative Care";
      }
      if (challenge.isPvsPChallenge) {
        return "Program vs. Program";
      }
      if (challenge.isWellness) {
        return "Wellness";
      }
      if (challenge.between === "individuals") {
        return "Individual";
      }
      if (challenge.between === "groups") {
        return "Team";
      }
      return this._.capitalize(challenge.between);
    },

    isTodayBeforeChallengeStart(challenge) {
      return this.moment(challenge.startDate).isAfter(
        this.moment().startOf("day")
      );
    },

    isTodayAfterChallengeEnd(challenge) {
      return this.moment(this.moment().startOf("day")).isAfter(
        challenge.endDate
      );
    },

    challengeStartDate(challenge) {
      return this.date(challenge.startDate, "DATE_FORMAT_FULL_MONTH").formatted;
    },

    challengeEndDate(challenge) {
      return this.date(challenge.endDate, "DATE_FORMAT_FULL_MONTH").formatted;
    },

    daysRemainingInChallenge(challenge) {
      if (this.isTodayBeforeChallengeStart(challenge)) {
        return this.daysBetweenInclusive(
          this.challengeStartDate(challenge),
          this.challengeEndDate(challenge)
        );
      }
      if (this.isTodayAfterChallengeEnd(challenge)) {
        return "Ended";
      }
      return this.daysBetweenInclusive(
        this.today(),
        this.challengeEndDate(challenge)
      );
    },

    daysRemainingInChallengeText(challenge) {
      return this.daysRemainingInChallenge(challenge) === 1
        ? "day left"
        : "days left";
    },

    daysTillTallyText(challenge) {
      let tallyDate = this.moment(this.challengeEndDate(challenge)).add(
        2,
        "days"
      );
      let daysTillTally = this.daysBetweenInclusive(this.today(), tallyDate);

      if (this.moment(this.moment().startOf("day")).isAfter(tallyDate))
        return "Tallied";
      if (daysTillTally === 1) return "Tallies Today";
      if (daysTillTally === 2) return "Tallies Tomorrow";

      return "";
    },

    daysTillChallengeStart(challenge) {
      if (this.isTodayBeforeChallengeStart(challenge)) {
        return this.daysBetweenInclusive(
          this.today(),
          this.challengeStartDate(challenge)
        );
      }
      return "Started";
    },

    mapDescription(challenge) {
      return this._.get(challenge, "map.description", "");
    },

    mapImagePlaceholder() {
      return "https://walkertracker.s3.amazonaws.com/newui/placeholder/challenge_placeholder.jpg";
    }
  }
};
